module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent wallet"
  }, [_c('pageTitle', {
    attrs: {
      "title": "我的储值卡"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "open"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/wallet/noValue.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/wallet/openValueCard"
    }
  }, [_vm._v("开通储值卡")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('label', [_vm._v("您还没有储值卡哦")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6045796d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/noValueCard.vue
// module id = 1518
// module chunks = 18